
import { User, Bars } from '@vicons/fa';
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { formatHexAddress, formatNumber } from '../../../common';
import GlobalCurrencyIcon from '../icons/GlobalCurrencyIcon.vue';
import GlobalNetworkIcon from '../icons/GlobalNetworkIcon.vue';
import NetworkModal from './NetworkModal.vue';

import { EthersService as eth, convertToUSD, http } from '../services';
import { exchangeRatesAvailable } from '../data/global';

const navigationOptions = [
  { title: 'RACE', routeName: 'Racing' },
  { title: 'BREED', routeName: 'Breeding' },
  { title: 'HOUNDS', routeName: 'Hounds' },
  { title: 'LEADERBOARD', routeName: 'Leaderboards' }
];

export default defineComponent({
  components: { User, Bars, GlobalCurrencyIcon, GlobalNetworkIcon, NetworkModal },
  name: 'Header',
  setup () {
    const router = useRouter();
    const showNavMenu = ref(false);

    const showNetworkModal = ref(eth.reactive?.value?.network?.id == 0);
    const showWalletModal = ref(eth.connection == undefined);

    const changeRoute = (newRoute: string) => {
      router.push({ name: newRoute });
      showNavMenu.value = false;
    };


    // Initial Run
    http.unstoppableReverseResolution(eth.userAddress).then((data) => {
      eth.reactive.value.unstoppableDomain = data.meta.domain;
    }).catch(console.error);

    // Subscription for running the query on all connection events
    eth.connectionSubject.subscribe(() => {
      http.unstoppableReverseResolution(eth.userAddress).then((data) => {
        eth.reactive.value.unstoppableDomain = data.meta.domain;
      }).catch(console.error);
    });


    return {
      ethReactive: eth.reactive,
      eth,
      router,
      changeRoute,
      showNetworkModal,
      navigationOptions,
      showNavMenu,
      showWalletModal,
      formatHexAddress,
      formatNumber,
      convertToUSD,
      exchangeRatesAvailable
    };
  }
});
